import { Trend, Value } from "@/ui/formats";
import { WalletPosition } from "@/api/positions/types";

const data = ["Bought", "Sold", "PNL", "Net PNL", "Net ROI"];

const TokenPositionStats = ({
  tokenPosition,
}: {
  tokenPosition: WalletPosition | undefined;
}) => {
  return (
    <div className="mt-[0.938rem] px-[0.625rem] flex flex-col gap-y-[0.313rem]">
      <div className="flex items-center justify-between">
        {data.map((item) => (
          <span key={item} className="text-xs font-semibold flex-1 text-center">
            {item}
          </span>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <div className="flex-1 flex justify-center">
          <Value value={tokenPosition?.invested ?? 0} withSign={false} />
        </div>
        <div className="flex-1 flex justify-center">
          <Value value={tokenPosition?.sold ?? 0} withSign={false} />
        </div>
        <div className="flex-1 flex justify-center">
          <Value
            value={tokenPosition?.realized_pnl ?? 0}
            withSign={false}
            positiveNegativeColor
            withTrendArrow
            smallSpace
          />
        </div>
        <div className="flex-1 flex justify-center">
          <Value
            value={tokenPosition?.net_pnl ?? 0}
            withSign={false}
            positiveNegativeColor
            withTrendArrow
            smallSpace
          />
        </div>
        <div className="flex-1 flex justify-center">
          <Trend
            value={tokenPosition?.net_pnl_percentage ?? 0}
            withSign={false}
            withTrendArrow
            smallSpace
          />
        </div>
      </div>
    </div>
  );
};

export default TokenPositionStats;
